import React from 'react';
import OnboardDevice from '../../features/account/device-care/onboard-device/onboard-device';
const Onboarding = () => {
  return <OnboardDevice data-sentry-element="OnboardDevice" data-sentry-component="Onboarding" data-sentry-source-file="onboarding.tsx" />;
};
export default Onboarding;